// test2553
(2553 && 0);
